import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { TableColumn } from 'src/app/shared-components/data-table/data-table.component';

@Component({
    selector: 'app-admin-payment-requests',
    templateUrl: './admin-payment-requests.component.html',
    styleUrls: ['./admin-payment-requests.component.scss'],
    standalone: false
})
export class AdminPaymentRequestsComponent implements OnInit {
  readonly columns: TableColumn[] = [
    { field: 'UserNmae', header: 'User Name' },
    { field: 'amountRequested', header: 'Amount Requested' },
    { field: 'dateodDeposit', header: 'Date of Deposit' },
    { field: 'payNow', header: 'Pay Now', toggleable: false },
    { field: 'status', header: 'status' },
    { field: 'distribution', header: 'Distribution', toggleable: false },
  ];

  states: any;
  selectedState:any;
  amountbalance= '2.5cr';
  selectedDate: any;
  payRequest: any=[];
  pageNo: number = 1;
  totalRecords:number = 10;
  displayBranch! : any ;
  
  constructor(private storageService:StorageService,private router: Router, private exportExcelService:ExportExcelService,    private userDashboardService:UserDashboardService,private cookieService: CookieService
    ) { 
    this.userDashboardService.getBranchList().subscribe((res:any)=>{
    
      this.states = res['content'];
      this.displayBranch = this.storageService.getBranch() || null;
      this.displayBranch = this.displayBranch.name;
    
  });
  this.payRequest = [
  {UserNmae: 'Aditya', amountRequested:'1.3 Cr',dateodDeposit:'23/03/23',status:'Deposited'},
  {UserNmae: 'Manjula', amountRequested:'90 L',dateodDeposit:'15/03/23',status:'Pending'},
  {UserNmae: 'NIkhil', amountRequested:'1 Cr',dateodDeposit:'13/03/23',status:'Deposited'},
  {UserNmae: 'Abhjit', amountRequested:'2 Cr',dateodDeposit:'07/03/23',status:'Pending'},
  {UserNmae: 'Praveen', amountRequested:'40 L',dateodDeposit:'02/03/23',status:'Deposited'},

  ];
  }

  ngOnInit(): void {
  }

  gotoDashboard(){
    this.router.navigate(['doqfy/admin-dashboard']);
  }

  export(){
    this.exportExcelService.convertToExcel(this.payRequest,'payRequest');
  }
  
  onPageChange(event:any){

     }

     viewDistribution(){
      this.router.navigate(['/doqfy/wallet/distribution']);
     }
     getSelected(){
      this.cookieService.set('BranchName', this.selectedState);
  this.storageService.setBranch(this.selectedState)
    }
}
